import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Dashboard from './components/dashboard/Dashboard';
import Admin from './components/admin/Admin';
import Market from './components/market/Market';
import Listing from './components/market/Listing';
import TradingBook from './components/trading-book/TradingBook';
import Welcome from './components/welcome/Welcome';
import Notifications from 'react-notify-toast';
import Logo from './res/logo.svg'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

/*
Week #9: Todo

1. Cash Verification - DONE
2. Portfolio Value Component - DONE
3. OTC Ordering - DONE
4. T+2 Checking (might need another server for this lmao)
*/

import './style.scss';

const App = (props) => {
    return (
        <BrowserRouter>
            <div id="outer-container"
                className={
                    'App darkBackground'
                } >
                <Switch>
                    <Route exact path="/" component={Welcome} />
                    <Route path="/dashboard" component={Dashboard} />
                    <Route path="/admin" component={Admin} />
                    <Route exact path="/market/:company" component={Listing} />
                    <Route path="/market" component={Market} />
                    <Route path="/trading-book" component={TradingBook} />
                    <Route path="/welcome" component={Welcome} />
                    <Route path="/admin" component={Admin} />
                </Switch>
                <Notifications />
            </div>
            <footer>
                <div className="footerLogo">
                    <img src={Logo} alt="Logo" />
                </div>
                <div className="footerInformation">
                    &copy; Building Block Trade | Designed and Built by DALI
                </div>
            </footer>
        </BrowserRouter>
    );
};

export default App;
